<template>
    <v-snackbar
      v-model="showSnack"
      :color="snackResponse.color"
      multi-line>
      {{ snackResponse.texto }}
      <template
          v-slot:action="{ attrs }">
          <v-btn
              text
              v-bind="attrs"
              @click="cerrar">
              cerrar
          </v-btn>
      </template>
    </v-snackbar>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'GlobalSnackBar',
  data() {
    return {
      showSnack: false,
    };
  },
  methods: {
    cerrar() {
      const respuesta = {
        mostrar: false,
        texto: '',
        color: '',
      };
      this.$store.commit('configuracion/MOSTRAR_RESPUESTA', { respuesta });
    },
  },
  computed: {
    ...mapGetters({
      snackResponse: 'configuracion/snackResponse',
    }),
  },
  watch: {
    '$store.state.configuracion.snackResponse': {
      handler(respuesta) {
        this.showSnack = respuesta.mostrar;
      },
      deep: true,
    },
    showSnack: {
      handler(newVal) {
        const respuesta = {
          mostrar: false,
          texto: '',
          color: '',
        };
        if (!newVal) {
          this.$store.commit('configuracion/MOSTRAR_RESPUESTA', { respuesta });
        }
      },
    },
  },
};
</script>

<style lang="scss">

</style>
